import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'shared/components/Icon';
import classes from './CalendarControls.module.scss';

const CalendarControls = ({ date, onNavigate }) => {
  const monthText = date.format('MMMM');
  const yearText = date.format('YYYY');

  const onNext = onNavigate ? () => onNavigate(date.clone().add(1, 'month')) : null;
  const onPrev = onNavigate ? () => onNavigate(date.clone().subtract(1, 'month')) : null;

  return (
    <div className={classes.container}>
      <div className={classes.current_month}>
        <span className={classes.month_label}>{monthText}</span>
        <span className={classes.year_label}>{yearText}</span>
      </div>
      <div className={classes.arrows}>
        <span className={`${classes.arrow} noselect`} onClick={onPrev}>
          <Icon name="chevron-left" />
        </span>
        <span className={`${classes.arrow} noselect`} onClick={onNext}>
          <Icon name="chevron-right" />
        </span>
      </div>
    </div>
  );
};

CalendarControls.displayName = 'CalendarControls';

CalendarControls.propTypes = {
  date: PropTypes.object,
  onNavigate: PropTypes.func,
};

export default CalendarControls;
